import axios from "axios";
import React, { useContext, useEffect, useReducer } from "react";
import reducer from "../reducers/products_reducer";
import { products_url as url } from "../utils/constants";
import { single_product_url as product_url } from "../utils/constants";
import {
  SIDEBAR_OPEN,
  SIDEBAR_CLOSE,
  GET_PRODUCTS_BEGIN,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_ERROR,
  GET_SINGLE_PRODUCT_BEGIN,
  GET_SINGLE_PRODUCT_SUCCESS,
  GET_SINGLE_PRODUCT_ERROR,
} from "../actions";

const initialState = {
  isSideBarOpen: false,
  productsLoading:false,
  singleLoading:false,
  singleError:false,
  productsError:false,
  products:[],
  product:{},
  featured:[],

}

const ProductsContext = React.createContext();

export const ProductsProvider = ({ children }) => {
  
  const [state, dispatch] = useReducer(reducer, initialState)

  const openSideBar = () => {
    console.log('open')
    dispatch({ type: SIDEBAR_OPEN });
  }
  const closeSideBar = () => {
    console.log('close')
    dispatch({ type: SIDEBAR_CLOSE });
  }

  const fetchProducts = async(url) =>{
    dispatch({type:GET_PRODUCTS_BEGIN})
    try {
      const response = await axios.get(url)
      const products = response.data
      dispatch({type: GET_PRODUCTS_SUCCESS, payload: products})
    } catch (error) {
      dispatch({type:GET_PRODUCTS_ERROR})
    }
    
  }

  const fetchSingleProduct = async(url) =>{
    dispatch({type:GET_SINGLE_PRODUCT_BEGIN})
    try {
      const response = await axios.get(url)
      const product = response.data
      dispatch({type: GET_SINGLE_PRODUCT_SUCCESS, payload: product})
    } catch (error) {
      dispatch({type:GET_SINGLE_PRODUCT_ERROR})
    }
    
  }

  useEffect(()=>{fetchProducts(url)},[])

  return (
    <ProductsContext.Provider value={{ ...state, openSideBar, closeSideBar, fetchSingleProduct}}>
      {children}
    </ProductsContext.Provider>
  )
};
// make sure use
export const useProductsContext = () => {
  return useContext(ProductsContext);
};
